import { useState } from 'react'
import { useBrandColors } from '../../hooks/useBrandColors'

const visitorLog = [
  { id:1, name:'Dr. Sarah Chen', company:'NIH Grant Review', host:'Tiffany Gallagher', purpose:'Grant Review Meeting', badge:'V-001', signIn:'8:45 AM', signOut:'11:30 AM', date:'Apr 2, 2025', status:'out', signed:true },
  { id:2, name:'Mark Peterson', company:'Dell Technologies', host:'John Gallagher', purpose:'IT Equipment Delivery', badge:'V-002', signIn:'9:15 AM', signOut:null, date:'Apr 2, 2025', status:'in', signed:true },
  { id:3, name:'Lisa Hartwell', company:'Hartwell Consulting', host:'Kim Park', purpose:'HR Compliance Review', badge:'V-003', signIn:'10:00 AM', signOut:null, date:'Apr 2, 2025', status:'in', signed:true },
  { id:4, name:'James O\'Brien', company:'State of Maine DOL', host:'Tiffany Gallagher', purpose:'Labor Audit', badge:'V-004', signIn:'1:00 PM', signOut:null, date:'Apr 2, 2025', status:'in', signed:true },
  { id:5, name:'Rachel Torres', company:'Independent', host:'Dana Lee', purpose:'Job Interview', badge:'V-005', signIn:'2:30 PM', signOut:'3:15 PM', date:'Apr 2, 2025', status:'out', signed:true },
]

const hosts = ['Tiffany Gallagher','John Gallagher','Kim Park','Dana Lee','Sam Rivera','Jamie Mitchell','Jordan Collins','Paula Reyes']
const purposes = ['Meeting','Interview','Delivery','Maintenance','Audit / Inspection','Training','Tour','Vendor Visit','Other']

export default function AdminVisitors() {
  const { accent, accentBg } = useBrandColors()
  const [visitors, setVisitors] = useState(visitorLog)
  const [filter, setFilter] = useState('All')
  const [showDetail, setShowDetail] = useState(null)
  const [toast, setToast] = useState(null)
  const [showManualAdd, setShowManualAdd] = useState(false)
  const [newVisitor, setNewVisitor] = useState({ name:'', company:'', host:'', purpose:'Meeting', notes:'' })

  function showToast(msg) { setToast(msg); setTimeout(()=>setToast(null), 3000) }

  function signOut(id) {
    const now = new Date()
    const timeStr = now.toLocaleTimeString('en-US',{hour:'numeric',minute:'2-digit',hour12:true})
    setVisitors(vs => vs.map(v => v.id===id ? {...v, signOut:timeStr, status:'out'} : v))
    if (showDetail?.id === id) setShowDetail(v => ({...v, signOut:timeStr, status:'out'}))
    showToast('Visitor signed out successfully')
  }

  function addManualVisitor() {
    if (!newVisitor.name || !newVisitor.host) { alert('Name and host are required.'); return }
    const now = new Date()
    const timeStr = now.toLocaleTimeString('en-US',{hour:'numeric',minute:'2-digit',hour12:true})
    const badge = 'V-' + String(visitors.length + 1).padStart(3,'0')
    const v = { ...newVisitor, id: Date.now(), badge, signIn: timeStr, signOut: null, date: 'Apr 2, 2025', status: 'in', signed: false }
    setVisitors(vs => [v, ...vs])
    setShowManualAdd(false)
    setNewVisitor({ name:'', company:'', host:'', purpose:'Meeting', notes:'' })
    showToast(`${newVisitor.name} added to visitor log`)
  }

  const filtered = filter === 'All' ? visitors : filter === 'In' ? visitors.filter(v=>v.status==='in') : visitors.filter(v=>v.status==='out')
  const currentlyIn = visitors.filter(v=>v.status==='in').length

  const inputStyle = { width:'100%', padding:'8px 12px', border:'1px solid #EDE6DA', borderRadius:6, fontSize:12, fontFamily:"'Montserrat',sans-serif", outline:'none', boxSizing:'border-box' }
  const labelStyle = { display:'block', fontSize:9, textTransform:'uppercase', letterSpacing:'0.1em', color:'#6B7D6B', fontWeight:600, marginBottom:5 }

  return (
    <div style={{fontFamily:"'Montserrat',sans-serif"}}>

      {toast && (
        <div style={{position:'fixed',top:20,right:24,zIndex:2000,background:'#2B2B2B',color:'#fff',padding:'12px 18px',borderRadius:8,fontSize:12,fontWeight:500,boxShadow:'0 4px 20px rgba(0,0,0,0.2)',display:'flex',alignItems:'center',gap:10}}>
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="#4A7C59" strokeWidth="1.5"/><path d="M5 8l2 2 4-4" stroke="#4A7C59" strokeWidth="1.5" strokeLinecap="round"/></svg>
          {toast}
        </div>
      )}

      {/* Visitor Detail Modal */}
      {showDetail && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',zIndex:500,display:'flex',alignItems:'center',justifyContent:'center',padding:24}} onClick={()=>setShowDetail(null)}>
          <div style={{background:'#fff',borderRadius:12,width:'100%',maxWidth:480,boxShadow:'0 8px 40px rgba(0,0,0,0.2)'}} onClick={e=>e.stopPropagation()}>
            <div style={{padding:'18px 24px',borderBottom:'1px solid #EDE6DA',background:'#F7F2EB',borderRadius:'12px 12px 0 0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div>
                <div style={{fontFamily:'Georgia,serif',fontSize:17,fontWeight:600,color:'#2B2B2B'}}>{showDetail.name}</div>
                <div style={{fontSize:11,color:'#8A9E8A',marginTop:2}}>{showDetail.company} · Badge {showDetail.badge}</div>
              </div>
              <div style={{display:'flex',alignItems:'center',gap:8}}>
                <span style={{fontSize:11,padding:'3px 10px',borderRadius:20,fontWeight:600,background:showDetail.status==='in'?'rgba(74,124,89,0.1)':'rgba(107,125,107,0.1)',color:showDetail.status==='in'?'#4A7C59':'#6B7D6B'}}>
                  {showDetail.status==='in'?'Currently Inside':'Signed Out'}
                </span>
                <button onClick={()=>setShowDetail(null)} style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'#8A9E8A'}}>×</button>
              </div>
            </div>
            <div style={{padding:'20px 24px',display:'flex',flexDirection:'column',gap:12}}>
              {[['Host','host'],['Purpose','purpose'],['Sign In','signIn'],['Sign Out','signOut'],['Date','date']].map(([label,key])=>(
                <div key={key} style={{display:'flex',justifyContent:'space-between',padding:'8px 0',borderBottom:'1px solid #EDE6DA'}}>
                  <span style={{fontSize:11,color:'#6B7D6B',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.08em'}}>{label}</span>
                  <span style={{fontSize:12,color:'#2B2B2B',fontWeight:500}}>{showDetail[key] || '—'}</span>
                </div>
              ))}
              {showDetail.signed && (
                <div style={{padding:'10px 14px',background:'rgba(74,124,89,0.06)',border:'1px solid rgba(74,124,89,0.2)',borderRadius:8,fontSize:11,color:'#4A7C59'}}>
                  ✓ NDA / Visitor Agreement signed on arrival
                </div>
              )}
              {showDetail.status === 'in' && (
                <button onClick={()=>{signOut(showDetail.id);setShowDetail(null)}} style={{padding:'10px',background:'#A0392B',border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",marginTop:4}}>
                  Sign Out This Visitor
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Manual Add Modal */}
      {showManualAdd && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',zIndex:500,display:'flex',alignItems:'center',justifyContent:'center',padding:24}} onClick={()=>setShowManualAdd(false)}>
          <div style={{background:'#fff',borderRadius:12,width:'100%',maxWidth:440,boxShadow:'0 8px 40px rgba(0,0,0,0.2)'}} onClick={e=>e.stopPropagation()}>
            <div style={{padding:'18px 24px',borderBottom:'1px solid #EDE6DA',background:'#2B2B2B',borderRadius:'12px 12px 0 0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:16,fontWeight:600,color:'#fff'}}>Manual Visitor Sign-In</div>
              <button onClick={()=>setShowManualAdd(false)} style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'rgba(255,255,255,0.5)'}}>×</button>
            </div>
            <div style={{padding:'20px 24px',display:'flex',flexDirection:'column',gap:14}}>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                <div style={{gridColumn:'1/-1'}}>
                  <label style={labelStyle}>Visitor Name *</label>
                  <input value={newVisitor.name} onChange={e=>setNewVisitor(n=>({...n,name:e.target.value}))} placeholder="Full name" style={inputStyle}/>
                </div>
                <div>
                  <label style={labelStyle}>Company / Organization</label>
                  <input value={newVisitor.company} onChange={e=>setNewVisitor(n=>({...n,company:e.target.value}))} placeholder="Optional" style={inputStyle}/>
                </div>
                <div>
                  <label style={labelStyle}>Host *</label>
                  <select value={newVisitor.host} onChange={e=>setNewVisitor(n=>({...n,host:e.target.value}))} style={inputStyle}>
                    <option value="">Select host...</option>
                    {hosts.map(h=><option key={h}>{h}</option>)}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Purpose</label>
                  <select value={newVisitor.purpose} onChange={e=>setNewVisitor(n=>({...n,purpose:e.target.value}))} style={inputStyle}>
                    {purposes.map(p=><option key={p}>{p}</option>)}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Notes</label>
                  <input value={newVisitor.notes} onChange={e=>setNewVisitor(n=>({...n,notes:e.target.value}))} placeholder="Optional" style={inputStyle}/>
                </div>
              </div>
              <div style={{display:'flex',justifyContent:'flex-end',gap:10,paddingTop:4,borderTop:'1px solid #EDE6DA'}}>
                <button onClick={()=>setShowManualAdd(false)} style={{padding:'8px 16px',border:'1px solid #EDE6DA',borderRadius:6,background:'#fff',fontSize:12,fontWeight:600,color:'#4A4A4A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Cancel</button>
                <button onClick={addManualVisitor} style={{padding:'8px 18px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Sign In Visitor</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div style={{marginBottom:20,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div>
          <h1 style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#2B2B2B',fontWeight:600}}>Visitor Management</h1>
          <p style={{fontSize:11,color:'#6B7D6B',marginTop:2}}>Track guests, contractors, and visitors on-site</p>
        <div style={{marginTop:8,padding:'8px 14px',background:'rgba(184,115,74,0.08)',border:'1px solid rgba(184,115,74,0.2)',borderRadius:6,fontSize:11,color:'#B8734A',display:'flex',alignItems:'center',gap:8}}><span style={{fontWeight:600}}>Demo mode:</span> Visitor kiosk data flows here automatically when connected to live database. Use Manual Sign-In to demo the admin flow, or click Open Kiosk Mode to try the visitor experience.</div>
        </div>
        <div style={{display:'flex',gap:8}}>
          <button onClick={()=>setShowManualAdd(true)} style={{padding:'8px 16px',border:'1px solid #EDE6DA',borderRadius:6,background:'#fff',fontSize:12,fontWeight:600,color:'#4A4A4A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>+ Manual Sign-In</button>
          <button onClick={()=>window.open('/visitor','_blank')} style={{padding:'8px 16px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Open Kiosk Mode →</button>
        </div>
      </div>

      {/* Stats */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:10,marginBottom:16}}>
        {[
          {label:'Currently On-Site', value:currentlyIn, color:'#4A7C59'},
          {label:'Signed Out Today', value:visitors.filter(v=>v.status==='out').length, color:accent},
          {label:'Total Visitors Today', value:visitors.length, color:'#4A6B8A'},
          {label:'NDAs Signed Today', value:visitors.filter(v=>v.signed).length, color:'#6B7D6B'},
        ].map(s=>(
          <div key={s.label} style={{background:'#fff',border:`1px solid ${s.color}22`,borderRadius:10,padding:'12px 16px'}}>
            <div style={{fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:500,marginBottom:4}}>{s.label}</div>
            <div style={{fontFamily:'Georgia,serif',fontSize:'1.6rem',color:s.color,fontWeight:600}}>{s.value}</div>
          </div>
        ))}
      </div>

      {/* Filter + table */}
      <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
        <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
          <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Today's Visitor Log — April 2, 2025</div>
          <div style={{display:'flex',gap:6}}>
            {['All','In','Out'].map(f=>(
              <button key={f} onClick={()=>setFilter(f)}
                style={{padding:'4px 14px',border:`1px solid ${filter===f?accent:'#EDE6DA'}`,borderRadius:20,background:filter===f?accent:'#fff',color:filter===f?'#fff':'#4A4A4A',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                {f==='In'?'On-Site':f==='Out'?'Signed Out':f}
              </button>
            ))}
          </div>
        </div>
        <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
          <thead>
            <tr style={{background:'#F7F2EB'}}>
              {['Badge','Visitor','Company','Host','Purpose','Sign In','Sign Out','Status',''].map(h=>(
                <th key={h} style={{textAlign:'left',padding:'8px 14px',fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,borderBottom:'1px solid #EDE6DA'}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map(v=>(
              <tr key={v.id} style={{borderBottom:'1px solid #EDE6DA',cursor:'pointer'}}
                onMouseEnter={e=>e.currentTarget.style.background='rgba(184,115,74,0.03)'}
                onMouseLeave={e=>e.currentTarget.style.background='transparent'}
                onClick={()=>setShowDetail(v)}>
                <td style={{padding:'11px 14px'}}>
                  <span style={{fontSize:10,padding:'2px 7px',borderRadius:4,background:'rgba(74,107,138,0.08)',color:'#4A6B8A',fontWeight:700}}>{v.badge}</span>
                </td>
                <td style={{padding:'11px 14px',fontWeight:600,color:'#2B2B2B'}}>{v.name}</td>
                <td style={{padding:'11px 14px',color:'#6B7D6B'}}>{v.company||'—'}</td>
                <td style={{padding:'11px 14px',color:'#4A4A4A'}}>{v.host}</td>
                <td style={{padding:'11px 14px'}}>
                  <span style={{fontSize:10,padding:'2px 7px',borderRadius:8,background:'#F7F2EB',color:'#6B7D6B'}}>{v.purpose}</span>
                </td>
                <td style={{padding:'11px 14px',color:'#4A4A4A',fontWeight:500}}>{v.signIn}</td>
                <td style={{padding:'11px 14px',color:v.signOut?'#4A4A4A':'#4A7C59',fontWeight:v.signOut?400:600}}>
                  {v.signOut || 'Still on-site'}
                </td>
                <td style={{padding:'11px 14px'}}>
                  <span style={{display:'inline-flex',alignItems:'center',gap:5,fontSize:11,fontWeight:600,color:v.status==='in'?'#4A7C59':'#6B7D6B'}}>
                    <span style={{width:7,height:7,borderRadius:'50%',background:v.status==='in'?'#4A7C59':'#8A9E8A',display:'inline-block'}}></span>
                    {v.status==='in'?'On-Site':'Signed Out'}
                  </span>
                </td>
                <td style={{padding:'11px 14px'}}>
                  {v.status==='in' && (
                    <button onClick={e=>{e.stopPropagation();signOut(v.id)}}
                      style={{padding:'4px 10px',border:'1px solid #A0392B',borderRadius:4,background:'rgba(160,57,43,0.06)',color:'#A0392B',fontSize:10,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                      Sign Out
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
